import { useNavigate } from 'react-router-dom';
import { Fingerprint } from 'lucide-react';

export function PublicFooter() {
  const navigate = useNavigate();

  const links = [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'Documentation', href: '/docs' },
    { label: 'Connect to Claude', action: () => navigate('/settings') },
    { label: 'Contact', href: 'mailto:fivedollarworkday@gmail.com' },
  ];

  return (
    <footer className="bg-brand-slate border-t border-slate-200 py-16 px-4 text-center">
      <div className="max-w-3xl mx-auto">

        {/* Logo + tagline */}
        <div className="mb-10">
          <div className="flex items-center justify-center gap-2 mb-2">
            <Fingerprint size={18} className="text-slate-900" />
            <span className="font-bold text-xl text-slate-900">Buildlog</span>
          </div>
          <p className="text-sm text-slate-400">Build in public, with Claude.</p>
        </div>

        {/* Links */}
        <nav className="flex flex-wrap justify-center gap-6 mb-10">
          {links.map(({ label, href, action }) =>
            action ? (
              <button
                key={label}
                onClick={action}
                className="text-sm text-slate-400 hover:text-slate-900 transition-colors bg-transparent border-none cursor-pointer"
              >
                {label}
              </button>
            ) : (
              <a
                key={label}
                href={href}
                className="text-sm text-slate-400 hover:text-slate-900 transition-colors no-underline"
              >
                {label}
              </a>
            )
          )}
        </nav>

        <div className="w-full h-px bg-slate-200 mb-8" />

        <div className="flex flex-col items-center gap-4">
          <p className="text-sm text-slate-400">© {new Date().getFullYear()} Buildlog. All rights reserved.</p>
          <a
            href="https://fivedollar.web.app"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full hover:bg-white transition-colors no-underline"
          >
            <span className="text-xs text-slate-400">Made by</span>
            <img
              src="/factory.png"
              alt="Five Dollar Workday"
              className="w-5 h-5 rounded-full border border-slate-200 object-cover"
            />
            <span className="text-sm font-semibold text-slate-900">Five Dollar Workday</span>
          </a>
        </div>

      </div>
    </footer>
  );
}